<template>
  <!-- <div class="i-use-item">{{ name }} : {{ gender }}</div> -->

  <div class="i-use-item-empty">
    <div class="item">
      <div class="icon">
        <img :src="require('@/assets/icons/' + (icon || 'icon1.png'))" alt="" />
      </div>

      <div class="lab">{{ label }}</div>

      <div class="amount"><i class="fas fa-pen"></i></div>
    </div>
  </div>
</template>

<script>
// import { computed } from '@vue/runtime-core';
export default {
  name: "UseItemEmpty",
  props: ["icon", "label"],
  //   data() {
  //     return {
  //       message: "2000000",
  //     };
  //   },
  //   methods: {
  //       change(){
  //           console.log('change', this.message);
  //       },
  //       onEnter(){
  //           this.$emit('onenter', this.message)
  //       }
  //   },
};
</script>
<style scoped>
.i-use-item-empty {
  background: #f1f2f4;
}
.i-use-item-empty .item {
  height: 80px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.i-use-item-empty .item .icon {
  width: 37px;
  font-size: 0;
  filter: grayscale(1) brightness(1.3);
}
.i-use-item-empty .item .icon img {
  width: 100%;
}
.i-use-item-empty .item .lab {
  font-size: 18px;
  margin-left: 16px;
  color: black;
  font-weight: bold;
}
.i-use-item-empty .item .amount {
  margin-left: auto;
}
.i-use-item-empty .item .amount i {
  font-size: 15px;
  color: #0085ff;
}
</style>

